<template>
    <div>
       <div class='account' @click='checkUserLoggedIn'>
            <i class="fa-light fa-user account-icon"></i>
       </div>
    </div>
</template>

<script>
import {checkAuth} from "@/global/modules/functions.js";

export default {
    methods:{
        async checkUserLoggedIn(){
            let response = await fetch(`/api/user/check-logged-in`, {
                method: 'GET',
                credentials: 'include'
            });

            let results = await checkAuth(response);
            
            if (response.status === 200){

                if(!results){
                    this.$router.push("/login");
                }
                else{
                    this.$router.push("/account");
                }
            }
        }
    }
}
</script>

<style lang="scss" scoped>

.account{
    cursor: pointer;
}

.account-icon{
    font-size: 1.4rem;

    @media(max-width:768px){
        font-size: 1.2rem;
    }
}

</style>